<template>
	<v-card
		text
		flat
		width="100%"
		:color="backgroundColor"
		:style="{ height: height + 'px !important' }"
	>
		<v-card-text class="text-center">
			<div v-if="title != 'Sin titulo'" :style="{ color: fontColor }" class="title">
				{{ title }}
			</div>
			<div :style="{ color: fontColor }">
				{{ msj }}
				<v-btn
					v-if="action"
					class="ma-2"
					@click="() => $router.replace({ name: action })"
					small
					>Ir</v-btn
				>
			</div>
		</v-card-text>
	</v-card>
</template>

<script>
export default {
	props: {
		title: {
			type: String,
			default: 'Sin datos',
		},
		backgroundColor: {
			type: String,
			default: '#ffebce',
		},
		fontColor: {
			type: String,
			default: '#ce7b00',
		},
		msj: {
			type: String,
			required: true,
		},
		height: {
			type: String,
			default: '100',
		},
		action: {
			type: String,
			default: '',
		},
	},
};
</script>
